import React, { useState, useEffect, useRef, useCallback } from 'react';
import axios from 'axios';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import DeadlineScrollBar from '../Sections/Deadline_ScrollBar/Deadline_ScrollBar';
import Swal from 'sweetalert2';

//import Select from '@material-ui/core/Select';
// import DeadlineScrollBar from ".."
import Navbar from '../Sections/Navbar/Navbar';
import StoreOpeningTime from '../Sections/StoreOpeningTime/StoreOpeningTime';
import AboutSection from '../Sections/AboutSection/AboutSection';
import VideoGallery from '../Sections/VideoGallery/VideoGallery';
import Hero2 from '../Sections/Header1/Hero/Hero';
import Clients from '../Sections/Clients/Clients';
import CalculatorsSection from '../Sections/CalculatorsSection/CalculatorsSection';
import FormSection from '../Sections/FormSection/FormSection';
import SMFeeds from '../Sections/SMFeeds/SMFeeds';
import Testimonials from '../Sections/Testimonials/Testimonials';
//import CalculatorsBar from '../Sections/CalculatorsBar/CalculatorsBar';
//import Map from '../Sections/Map/Map';
import Footer from '../Sections/Footer/Footer';
//import Blog from '../Sections/Blog/blog';
import Grid from '@material-ui/core/Grid';
import Photo from '../Assets/img/modal/popup_combined.jpg';
import Modal from 'react-modal';
import './homepage.css';
import services from '../../services';
import ClientCarousel from '../../components/Sections/Blog2/ClientCarosuel/ClientCarousel';
import ClientContent from '../../components/Sections/Blog2/ClientContent/Clientcontent';
import Clientcontentdata from '../../components/Sections/Blog2/ClientContent/ClientContentData';
//import PhoneInput from "react-phone-number-input/input";
import { withStyles } from '@material-ui/core/styles';

const CssTextField = withStyles({
  root: {
    '& .MuiInputBase-root': {
      color: 'white',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'white',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'blue',
      },
    },
  },
})(TextField);

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  margin: {
    margin: theme.spacing(1),
    width: '90%',
    marginTop: '5px',
    marginBottom: '5px',
    ['@media (min-width:427px) and (max-width:768px)']: {
      marginBottom: '20px',
    },
    ['@media (max-width:426px)']: {
      width: '100%',
      marginBottom: '25px',
      marginLeft: '0px',
      paddingLeft: '0px',
    },
  },
  margin2: {
    margin: theme.spacing(1),
    width: '90%',
    marginTop: '5px',
    marginBottom: '5px',
    ['@media (min-width:427px) and (max-width:768px)']: {
      marginBottom: '20px',
    },
    ['@media (max-width:426px)']: {
      width: '100%',
      marginBottom: '10px',
      marginLeft: '0px',
      paddingLeft: '0px',
    },
  },
  heading: {
    color: 'white',
    backgroundColor: 'blue',
    padding: '10px 5px',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    alignItems: 'center',
    overflowWrap: 'break-word',
    ['@media (max-width:426px)']: {
      fontSize: '15px',
      padding: '2px',
      justifyContent: 'left',
    },
  },
  ol: {
    fontSize: '20px',
    color: 'white',
  },
  grid: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    ['@media (max-width:768px)']: {
      display: 'none',
    },
  },
  phno: {
    marginLeft: '8px',
    marginTop: '15px',
    marginBottom: '15px',
    ['@media (max-width:768px)']: {
      display: 'flex',
      justifyContent: 'right',
    },
    ['@media (max-width:426px)']: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  grid2: {
    ['@media (max-width:425px)']: { display: 'flex', flexDirection: 'column' },
  },
  phnoinput: {
    marginLeft: '10px',
    marginTop: '10px !important',
    marginBottom: '10px !important',
    ['@media (max-width:426px)']: {
      // width: '100%',
      marginBottom: '15px !important',
    },
  },
}));

Modal.setAppElement('#root');
function Homepage(props) {
  const classes = useStyles();
  let abutton = useRef();
  const testimonialsRef = useRef();
  const [value, setValue] = useState();
  const [lang, setLang] = useState('en');
  const [currentCategory, setCurrentCategory] = useState('Accounting');
  const [ModalisOpen, setIsOpen] = useState(false);
  const [showform, setshowform] = useState(false);
  const nameRef = useRef();
  const phoneRef = useRef();
  const emailRef = useRef();
  const serviceRef = useRef();
  const messageRef = useRef();
  function setCategory(category) {
    setCurrentCategory(category);
  }
  const [size, setSize] = useState({
    x: window.innerWidth,
    y: window.innerHeight,
  });
  const updateSize = () =>
    setSize({
      x: window.innerWidth,
      y: window.innerHeight,
    });
  useEffect(() => (window.onresize = updateSize), []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    // when we go to calculator page and come back we need to get back to the same location where we left off
    // so we check if there is hash in url , then we click a dummy button which consists of href for the id
    if (window.location.hash === '#calculatorsSection') {
      abutton.current.click();
    }
    if (!window.sessionStorage.getItem('visited')) {
      setTimeout(() => {
        setIsOpen(true);
        sessionStorage.setItem('visited', true);
      }, 10000);
    } else {
    }
    const el = document.querySelector('#testimonials');
    window.addEventListener('scroll', () => {
      const bottom =
        Math.ceil(window.pageYOffset) >= testimonialsRef?.current?.offsetTop;
      if (bottom && !window.sessionStorage.getItem('visited')) {
        setIsOpen(true);
        sessionStorage.setItem('visited', true);
      }
    });
  }, []);
  const sendServiceRequest = async (event) => {
    console.log('Submitted');
    event.preventDefault();
    Swal.fire({
      icon: 'success',
      iconColor: 'rgb(200,172,72)',
      title: 'We will get to you soon',
      showConfirmButton: false,
      timer: 1500,
    });
    setIsOpen(false);
    const res = await axios.post(
      `https://${window.location.host}/users/request/service`,
      {
        name: nameRef.current.value,
        email: emailRef.current.value,
        phonevalue: phoneRef.current.value,
        message: messageRef.current.value,
        serviceSelected: serviceRef.current.value,
      }
    );
    console.log(res.data);
  };

  //for prop passing language
  const propLang = (language) => {
    setLang(language);
    console.log(language);
  };

  function disableWindowScroll() {
    document.body.style.overflow = 'hidden';
  }

  function enableWindowScroll() {
    document.body.style.overflow = 'auto';
  }
  if (ModalisOpen) {
    disableWindowScroll();
  } else enableWindowScroll();
  return (
    <div>
      <Modal
        isOpen={ModalisOpen}
        onRequestClose={() => setIsOpen(false)}
        contentLabel="My dialog"
        className={`${
          showform ? 'modalbackstyling2' : 'modalstyling'
        }  homepage`}
        style={{
          overlay: { backgroundColor: 'rgba(0,0,0,0.5)', zIndex: '99' },
        }}
      >
        {!showform ? (
          <>
            <div className="heading">Get in touch</div>
            <div className="desc">Pro Bono</div>
            <div
              className="click"
              onClick={() => {
                setshowform(true);
              }}
            >
              Click Here
            </div>
          </>
        ) : (
          <form
            className="input-group formstyle"
            onSubmit={sendServiceRequest}
            style={{ paddingBottom: '10px' }}
          >
            <h5 className={classes.heading}>
              Driven by Customer Focus. Guided by Experience.
            </h5>

            <Grid container fixed>
              <Grid items md={6} className={classes.grid}>
                <ol className={classes.ol}>
                  <li>Account assistant idbawidkb</li>
                  <li>Account assistant idbawidkb</li>
                  <li>Account assistant idbawidkb</li>
                </ol>

                <img src={Photo} alt="abnca" height="250" width="250" />
              </Grid>
              <Grid
                items
                sm={12}
                md={6}
                style={{ padding: '10px' }}
                className={classes.grid2}
              >
                {/* <input
                  type="text"
                  className="fields"
                  required
                  ref={nameRef}
                ></input> */}

                <CssTextField
                  className={classes.margin}
                  label="Name"
                  variant="outlined"
                  id="custom-css-outlined-input"
                  ref={nameRef}
                  InputLabelProps={{ style: { color: 'white' } }}
                  type="text"
                  required
                />
                <div className={classes.phno}>
                  {/* <label className="labels">Phone*:</label> */}

                  <PhoneInput
                    country={'in'}
                    // disableDropdown={true}
                    value={value}
                    onChange={setValue}
                    containerClass="containerclass"
                    inputClass="inputclass"
                    buttonClass="buttonclass"
                    required
                    ref={phoneRef}
                    // className={classes.phnoinput}
                  />
                </div>

                {/* <label className="labels">Email:</label> */}
                <CssTextField
                  className={classes.margin}
                  label="Email"
                  variant="outlined"
                  id="custom-css-outlined-input"
                  InputLabelProps={{ style: { color: 'white' } }}
                  ref={emailRef}
                  type="email"
                  required
                />
                {/* <input
                  type="email"
                  className="fields"
                  ref={emailRef}
                  style={{ marginBottom: '3px' }}
                ></input> */}
                <div className={classes.phnoinput}>
                  <label className="labels">Select Service:</label>
                  <select
                    defaultValue=" "
                    names="services"
                    className={`fields2`}
                    ref={serviceRef}
                    // style={{ marginBottom: '3px' }}
                  >
                    <option
                      style={{ display: 'none' }}
                      className="listitems"
                    ></option>
                    {services.map((val) => {
                      return <option className="listitems">{val.title}</option>;
                    })}
                    <option className="listitems">Other</option>
                  </select>
                </div>

                {/* <label className="labels">Message:</label> */}
                <CssTextField
                  className={classes.margin2}
                  label="Message"
                  variant="outlined"
                  id="custom-css-outlined-input"
                  InputLabelProps={{ style: { color: 'white' } }}
                  ref={messageRef}
                  rows="3"
                  columns="65"
                  multiline
                  required
                />

                {/* <textarea
                  className="textareas"
                  rows="3"
                  columns="65"
                  ref={messageRef}
                ></textarea> */}
                <div
                  className="button"
                  type="submit"
                  onClick={sendServiceRequest}
                  role="submit"
                >
                  Submit
                </div>
              </Grid>
            </Grid>
          </form>
        )}
      </Modal>
      <a ref={abutton} href="#calculatorsSection" className="d-none"></a>
      <DeadlineScrollBar selectedLang={lang} />
      <Navbar lang={propLang} />
      <Hero2 selectedLang={lang} />
      <StoreOpeningTime />
      {/* {props.showModal ? (
        <HeroSection setShowModal={props.setShowModal} />
      ) : null} */}
      <AboutSection selectedLang={lang} />
      <VideoGallery selectedLang={lang} />
      <CalculatorsSection
        category={currentCategory}
        setCategory={setCategory}
        selectedLang={lang}
      />{' '}
      <FormSection />
      {/* <Blog isService={false} /> */}
      {size.x > 580 ? (
        <ClientContent
          ClientContentData={Clientcontentdata}
          selectedLang={lang}
        />
      ) : (
        <ClientCarousel
          ClientContentData={Clientcontentdata}
          selectedLang={lang}
          style={{ height: 'auto', width: 'auto' }}
        />
      )}
      <SMFeeds selectedLang={lang} />
      <Clients selectedLang={lang} />
      <Testimonials ref={testimonialsRef} selectedLang={lang} />
      {/* <CalculatorsBar setCategory={setCategory} /> <Map /> */}
      <Footer selectedLang={lang} />
    </div>
  );
}

export default Homepage;
